import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45d03267"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "cover-background" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_tab_button = _resolveComponent("ion-tab-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_tab_bar = _resolveComponent("ion-tab-bar")!
  const _component_ion_tabs = _resolveComponent("ion-tabs")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createVNode(_component_ion_tabs, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_router_outlet),
          _withDirectives(_createElementVNode("div", null, [
            _withDirectives(_createVNode(_component_ion_tab_bar, {
              class: "pet-tab-bar",
              color: "primary",
              slot: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_tab_button, {
                  tab: "home",
                  href: "/home",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.checkScrollToTop()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: $setup.home }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_tab_button, {
                  layout: "label-hide",
                  tab: "place-overview",
                  href: "/place-overview"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: $setup.location }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.t('places')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_tab_button, {
                  style: {"margin-bottom":"30px"},
                  layout: "icon-top",
                  tab: "tools",
                  href: "/tools"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_img, {
                      style: {"width":"56px"},
                      src: $setup.currPath == '/tools' ? ($setup.settings.navBarCenterIconClicked || $setup.imgIcons.toolsWhite) :
                                              ($setup.settings.navBarCenterIcon || $setup.imgIcons.tools)
                    }, null, 8, ["src"]),
                    _createElementVNode("span", null, _toDisplayString($setup.t('tools').toUpperCase()), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_tab_button, {
                  layout: "label-hide",
                  tab: "info-overview",
                  href: "/info-overview"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: $setup.newspaper }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.t('infos')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_tab_button, {
                  layout: "label-hide",
                  tab: "profile",
                  href: "/profile"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: $setup.personCircle }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.t('profile')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, $setup.tabBarType == 'pet']
            ]),
            _withDirectives(_createVNode(_component_ion_tab_bar, {
              color: "primary",
              slot: "bottom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_tab_button, {
                  layout: "label-hide",
                  tab: "products",
                  href: "/products"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: $setup.storefrontOutline }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_tab_button, {
                  layout: "label-hide",
                  tab: "band-posts",
                  href: "/band-posts"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: $setup.newspaper }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_tab_button, {
                  layout: "label-hide",
                  tab: "certificates",
                  href: "/certificates"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: $setup.qrCodeOutline }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_tab_button, {
                  layout: "label-hide",
                  tab: "profile",
                  href: "/profile"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: $setup.personCircle }, null, 8, ["icon"]),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.t('profile')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, $setup.tabBarType == 'coral']
            ])
          ], 512), [
            [_vShow, !$setup.hideTabs && !$setup.forceHideBottomTabs]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}